import general from './general'
import elementUI from 'element-ui/lib/locale/lang/en'

const messages = { general, ...elementUI }

export default messages



// WEBPACK FOOTER //
// ./src/lang/en/index.js